import { AudioHighlightMetadataType } from '@modules/feedback/components/AudioType/types';
import { PredictionLabelType } from '@modules/feedback/types';

export const mapAudioHighlightMetadataType = (
  predictionLabelType: PredictionLabelType | undefined,
) => {
  switch (predictionLabelType) {
    case PredictionLabelType.Entity:
      return AudioHighlightMetadataType.TrackedKeyword;
    case PredictionLabelType.Reason:
      return AudioHighlightMetadataType.Reason;
    case PredictionLabelType.Search:
      return AudioHighlightMetadataType.Search;
    default:
      return null;
  }
};
